import {HttpClient} from '@angular/common/http';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {g_params} from 'src/app/classes/global-param';
import {ArmaServConnection} from 'src/app/classes/info-connection';
import {FavoriteShape, FavoriteShapeStatus, Formes} from 'src/app/classes/json-interface';
import {CUtilit} from 'src/app/classes/utilit';
import {DialogShapeSearch} from '../dialog/dialogShapeSearch/dialogShapeSearch';

@Component({
  selector: 'app-list-forme',
  templateUrl: './list-forme.component.html',
  styleUrls: ['./list-forme.component.css']
})
export class ListFormeComponent implements OnInit {
  @Output() public mInputRepartition: EventEmitter<any> = new EventEmitter();
  @Output() public mInputShape99: EventEmitter<any> = new EventEmitter();
  @Output('onShapeClick') public mOnShapeClick: EventEmitter<Formes> = new EventEmitter();  // Envoie la forme cliquée
  @Output('onMeshClick') public mOnWMeshCLick: EventEmitter<any> = new EventEmitter();

  @Input('disabled') HTML_DISABLED: boolean = false; // Bloque tout les input du composant
  @Input('Shapes') mFormesCatalogue: Formes[] = [];
  @Input('FavoriteShapes') mArrayFavoriteShape: FavoriteShape[] = [];

  constructor(private mHttp: HttpClient,
              public mDialog: MatDialog) {}

  ngOnInit() { }

  /**
   * Recuperer le tableau de forme du catalogue
   * @param onlySelectable retourne seulement les formes qui sont disponible sur armaWeb
   */

  HTML_OnShapeClick(forme: Formes) {
    if (this.HTML_DISABLED) return true; // On ne fait rien si c'est disabled
    this.mOnShapeClick.emit(forme);
  }

  shape99Click() {
    this.mInputShape99.emit(null);
  }

  inputRepartitionClick() {
    this.mInputRepartition.emit(null);
  }

  getShowInputDistribution(): boolean {
    return CUtilit.loadOrInitUserParam().InputDistribution;
  }

  public get HTML_OptionMesh(): boolean {
    return g_params.OPT_WMESH;
  }

  public IsFavorite(formes: Formes): boolean {
    const indexFavorite: number = this.mArrayFavoriteShape.map((val) => val.NoForme).indexOf(formes.CleForme);
    const favorite: boolean = indexFavorite != -1;
    // La forme est favorite si elle a le STATUS Favorite
    return favorite && this.mArrayFavoriteShape[indexFavorite].Status == FavoriteShapeStatus.Favorite;
  }

  public ToggleFavorite(event: Event, shape: Formes) {
    const indexFavorite: number = this.mArrayFavoriteShape.map((value) => value.NoForme).indexOf(shape.CleForme);
    let favoriteShape: FavoriteShape;
    // Si la forme n'avait pas de status favoris on affecte celui par défaut
    if (indexFavorite == -1) {
      favoriteShape = {NoForme: shape.CleForme, Status: FavoriteShapeStatus.Default, PanelVisible: false};
    } else {
      favoriteShape = this.mArrayFavoriteShape[indexFavorite];
    }
    // Si la forme est actuellement favorite
    if (favoriteShape.Status == FavoriteShapeStatus.Favorite) {
      if (shape.WebSelectable == 2) {
        favoriteShape.Status = FavoriteShapeStatus.PanelVisible;
      } else {
        favoriteShape.Status = FavoriteShapeStatus.Default;
        // Si le favoris existait, maintenant il n'y a plus de favoris pour cette forme, on la supprime de la liste (optionnel)
      }
    } else {
      favoriteShape.Status = FavoriteShapeStatus.Favorite;
      if (shape.WebSelectable == 2) {
        favoriteShape.PanelVisible = true;
      }
    }

    // Pas de favoris conçernant cette forme actuellement
    if (indexFavorite == -1) {
      this.mArrayFavoriteShape.push(favoriteShape);
    } else {
      this.mArrayFavoriteShape[indexFavorite] = favoriteShape;
    }

    this.UpdateShapeFavorite(shape, favoriteShape.Status, favoriteShape.PanelVisible);

    //On empêche la propagation de l'event de click (Pour pas générer de click sur la forme mais bien sur le bouton favorit)
    event.stopPropagation();
  }

  private async UpdateShapeFavorite(shape: Formes, favoriteStatus: FavoriteShapeStatus, panelVisible: boolean) {
    await ArmaServConnection.aPOST(this.mHttp, 'ShapeFavorite', {Shape: shape, Status: favoriteStatus, PanelVisible: panelVisible});
  }

  public GetSortedShapes(): Formes[] {
    const favoriteShapes: Formes[] = [];
    const nonFavoriteShapes: Formes[] = [];
    this.mFormesCatalogue.forEach(shape => {
      const indexFavorite: number = this.mArrayFavoriteShape.map((val) => val.NoForme).indexOf(shape.CleForme);
      if (indexFavorite != -1) {
        // SI on est pas dans le seul cas où on n'affiche pas la forme (Forme visible dans la recherche mais pas dans le panneau de liste de formes
        if (!(shape.WebSelectable == 2 && (!this.mArrayFavoriteShape[indexFavorite].PanelVisible))) {
          switch (this.mArrayFavoriteShape[indexFavorite].Status) {
            case FavoriteShapeStatus.Favorite:
              favoriteShapes.push(shape);
              break;
            case FavoriteShapeStatus.Default:
              nonFavoriteShapes.push(shape);
              break;
            case FavoriteShapeStatus.PanelVisible:
              nonFavoriteShapes.push(shape);
              break;
          }
        }
      }
    });
    return favoriteShapes.concat(nonFavoriteShapes);
  }

  async SearchShapeClick() {
    const result = await DialogShapeSearch.openDialog(this.mDialog, this.mArrayFavoriteShape);
  }

}
